<script lang="ts">
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { CircleAvatar, Container, Text } from '@Shelly/shelly-design-system/index';
	import { real_id } from 'src/helpers/interface_helpers';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { format } from 'svelte-i18n';

	export let device;
	export let hasMb = false;

	$: statusStore = getDeviceStatus(device.id);
	$: occupancy = $statusStore?.['distance:0']?.occupancy;
	$: baselineDistance = Number(device?.installationHeight);
	$: triggerDistance = Number(device?.triggerDistance);
</script>

{#if $showNewLayout}
	<div class="mt-l">
		<Text class="mb-s text-center text-color-3">
			{$format('label_parking_spot', { default: 'Parking Spot' })}
		</Text>
		{#if occupancy === 'error' || isNaN(baselineDistance) || isNaN(triggerDistance)}
			<Text styleType="h1" class="mb-m text-center text-300">
				{$format('common_out_of_range', {
					default: 'Out of range',
				})}
			</Text>
			<div class="d-flex justify-content-center">
				<CircleAvatar icon="far fa-triangle-exclamation" size="xxl" />
			</div>
		{:else if occupancy === 'occupied'}
			<Text styleType="h1" class="mb-s text-center text-300">
				{$format('label_occupied', { default: 'Occupied' })}
			</Text>
			<div class="d-flex justify-content-center">
				<img
					class="mt-s"
					src="./images/onboarding/distance/car_occupied.png"
					alt={$format('label_occupied', { default: 'Occupied' })}
				/>
			</div>
		{:else}
			<Text styleType="h1" class="mb-s text-center text-300">
				{$format('label_vacant', { default: 'Vacant' })}
			</Text>
			<div class="d-flex justify-content-center">
				<img
					class="mt-s"
					src="./images/onboarding/distance/car_vacant.png"
					alt={$format('label_vacant', { default: 'Vacant' })}
				/>
			</div>
		{/if}
	</div>
{:else}
	<div
		class={classMap({
			'occupancy-container': !hasMb,
			'mt-l': !hasMb,
		})}
	>
		<Container padding={hasMb ? 'l' : '0'}>
			<Text class="mb-s text-center text-color-3">
				{$format('label_parking_spot', { default: 'Parking Spot' })}
			</Text>
			{#if occupancy === 'error' || isNaN(baselineDistance) || isNaN(triggerDistance)}
				<Text styleType="h1" class="mb-m text-center text-300">
					{$format('common_out_of_range', {
						default: 'Out of range',
					})}
				</Text>
				<div class="d-flex justify-content-center">
					<CircleAvatar icon="far fa-triangle-exclamation" size="xxl" />
				</div>
			{:else if occupancy === 'occupied'}
				<Text styleType="h1" class="mb-s text-center text-300">
					{$format('label_occupied', { default: 'Occupied' })}
				</Text>
				<div class="d-flex justify-content-center">
					<img
						class="mt-s"
						src="./images/onboarding/distance/car_occupied.png"
						alt={$format('label_occupied', { default: 'Occupied' })}
					/>
				</div>
			{:else}
				<Text styleType="h1" class="mb-s text-center text-300">
					{$format('label_vacant', { default: 'Vacant' })}
				</Text>
				<div class="d-flex justify-content-center">
					<img
						class="mt-s"
						src="./images/onboarding/distance/car_vacant.png"
						alt={$format('label_vacant', { default: 'Vacant' })}
					/>
				</div>
			{/if}
		</Container>
	</div>
{/if}

<style>
	@media (min-width: 640px) {
		.occupancy-container {
			margin-left: 24px;
		}
	}
</style>
